module.exports = __webpack_public_path__ + "static/img/fingerpost_express_6.ff3a217.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_express_6.jpg
// module id = CB6L
// module chunks = 0